
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.8405 5C10.5899 5 10.3496 5.09658 10.1724 5.26849C9.99526 5.44039 9.89572 5.67355 9.89572 5.91667C9.89572 6.15978 9.99526 6.39294 10.1724 6.56485C10.3496 6.73676 10.5899 6.83333 10.8405 6.83333H13.0488L8.90892 17.1667H5.94478C5.69421 17.1667 5.4539 17.2632 5.27672 17.4352C5.09954 17.6071 5 17.8402 5 18.0833C5 18.3264 5.09954 18.5596 5.27672 18.7315C5.4539 18.9034 5.69421 19 5.94478 19H13.1595C13.4101 19 13.6504 18.9034 13.8276 18.7315C14.0047 18.5596 14.1043 18.3264 14.1043 18.0833C14.1043 17.8402 14.0047 17.6071 13.8276 17.4352C13.6504 17.2632 13.4101 17.1667 13.1595 17.1667H10.9512L15.0911 6.83333H18.0552C18.3058 6.83333 18.5461 6.73676 18.7233 6.56485C18.9005 6.39294 19 6.15978 19 5.91667C19 5.67355 18.9005 5.44039 18.7233 5.26849C18.5461 5.09658 18.3058 5 18.0552 5H10.8405Z","fill":"#10001F"}})])
          )
        }
      }
    